if (!customElements.get('add-to-wishlist-button')) {
  customElements.define(
    'add-to-wishlist-button',
    class AddToWishlistButton extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('button');
        this.buttonText = this.button.querySelector('.add-to-wishlist-button__text');
        this.addText = 'Add to wishlist';
        this.removeText = 'Remove from wishlist';
        this.iconEmpty = this.querySelector('.icon-wishlist-empty');
        this.iconFilled = this.querySelector('.icon-wishlist-filled');
        this.state = null;
      }
      connectedCallback() {
        this.button.addEventListener('click', this.handleButtonClick.bind(this));
        this.init();
        if (Number(this.dataset.wishlistPage) === 1) {
          this.updateState('added');
        }
      }
      disconnectedCallback() {
        this.button.removeEventListener('click', this.handleButtonClick);
      }
      async init() {
        const customerId = await handleLogIn();
        if (!customerId || !this.buttonText) return; // quit if they're not logged in or if you're on a collection page (don't want to search them one at a time!)

        const response = await fetch(
          'https://limelace-wishlist.etempashopifyapps-server-i.co.uk/endpoints/retrieve_single_item.php',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              customer_id: customerId,
              product_id: this.dataset.productId,
            }),
          }
        );
        const data = await response.json();
        //console.log(data);
        if (data.failed) {
          console.error('Error retrieving item from wishlist');
          throw new Error('Something went wrong retrieving your product from the wishlist');
        } else {
          if (data.in_wishlist) this.updateState('added');
        }
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }
      set productId(productId) {
        this.dataset.productId = productId;
      }
      get productId() {
        return this.dataset.productId;
      }
      set productHandle(productHandle) {
        this.dataset.productHandle = productHandle;
      }
      get productHandle() {
        return this.dataset.productHandle;
      }
      set variantId(variantId) {
        this.dataset.variantId = variantId;
      }
      get variantId() {
        return this.dataset.variantId;
      }
      set customerId(customerId) {
        this.dataset.customerId = customerId;
      }
      get customerId() {
        return this.dataset.customerId;
      }
      changeText(text) {
        if (!this.buttonText) return;

        this.buttonText.textContent = text;
      }
      setLoadingState() {
        this.button.classList.add('loading');
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove('hidden');
        }
      }
      removeLoadingState() {
        this.button.classList.remove('loading');
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.add('hidden');
        }
      }
      updateState(state) {
        if (state === 'added') {
          this.state = 'added';
          this.iconEmpty.style.display = 'none';
          this.iconFilled.style.display = 'block';
          this.changeText(this.removeText);
        } else {
          this.state = 'removed';
          this.iconEmpty.style.display = 'block';
          this.iconFilled.style.display = 'none';
          this.changeText(this.addText);
        }
        this.updateHeaderButtonCount();
      }
      updateHeaderButtonCount() {
        const wishlistHeaderButton = document.querySelectorAll('wishlist-header-button');
        if (!wishlistHeaderButton) return;
        Array.from(wishlistHeaderButton).map((button) => button.init());
      }
      updateWishlistViewer() {
        const wishlistViewer = document.querySelector('wishlist-viewer');
        if (!wishlistViewer) return;

        wishlistViewer.productGridContainer.innerHTML = '';
        wishlistViewer.init();
      }
      async addToWishlist() {
        this.setLoadingState();
        try {
          const customerId = await handleLogIn();
          if (!customerId) {
            //console.log(location.pathname + location.search + location.hash);
            window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(
              location.pathname + location.search + location.hash
            )}`;
            return false;
          }

          const response = await fetch(
            'https://limelace-wishlist.etempashopifyapps-server-i.co.uk/endpoints/add_to_wishlist.php',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                customer_id: customerId,
                product_id: this.dataset.productId,
                variant_id: this.dataset.variantId,
                product_handle: this.dataset.productHandle,
              }),
            }
          );
          const data = await response.json();
          if (data.failed) {
            console.error('Error adding item to wishlist');
            throw new Error('Something went wrong adding your product to the wishlist');
          } else {
            this.updateState('added');
            this.updateWishlistViewer();
          }
        } catch (error) {
          console.error('Error adding item to wishlist', error);
          throw new Error('Something went wrong adding your product to the wishlist');
        }
        this.removeLoadingState();
      }
      async removeFromWishlist() {
        this.setLoadingState();
        try {
          const customerId = await handleLogIn();
          if (!customerId) {
            window.location.href = `/customer_authentication/login?return_to=${encodeURIComponent(
              location.pathname + location.search + location.hash
            )}`;
          }

          const response = await fetch(
            'https://limelace-wishlist.etempashopifyapps-server-i.co.uk/endpoints/remove_from_wishlist.php',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                customer_id: customerId,
                product_id: this.dataset.productId,
              }),
            }
          );
          const data = await response.json();
          if (data.failed) {
            console.error('Error removing item to wishlist');
            throw new Error('Something went wrong removing your product to the wishlist');
          } else {
            this.updateState('removed');
            this.updateWishlistViewer();
          }
        } catch (error) {
          console.error('Error removing item to wishlist', error);
          throw new Error('Something went wrong removing your product to the wishlist');
        }
        this.removeLoadingState();
      }
      handleButtonClick(e) {
        e.preventDefault();
        if (this.button.classList.contains('loading')) return;

        if (this.state === null || this.state === 'removed') {
          this.addToWishlist();
        } else {
          this.removeFromWishlist();
        }
      }
    }
  );
}
